import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, LayoutGrid, Search, ShoppingBag, User } from "lucide-react";
import { useCjCart } from "../context/CjCartContext";
import { EXTERNAL_LINKS } from "../config";

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { count } = useCjCart();
  const active = (p) => (pathname === p ? "text-taven-orange" : "text-black/60");

  const items = [
    { label: "Home", icon: Home, to: "/" },
    { label: "Hub", icon: LayoutGrid, to: "/hub" },
    { label: "Search", icon: Search, action: () => navigate("/shop") },
    { label: "Cart", icon: ShoppingBag, to: "/cart", badge: count },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-black/10 flex justify-around items-center h-16 pb-safe lg:hidden" data-testid="mobile-bottom-nav">
      {items.map((it) => it.to ? (
        <Link key={it.label} to={it.to} className={`flex flex-col items-center gap-0.5 relative ${active(it.to)}`} data-testid={`bottomnav-${it.label.toLowerCase()}`}>
          <it.icon className="w-5 h-5" />
          {it.badge > 0 && <span className="absolute -top-1 right-3 bg-taven-orange text-white text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full">{it.badge}</span>}
          <span className="text-[10px] font-semibold">{it.label}</span>
        </Link>
      ) : (
        <button key={it.label} onClick={it.action} className="flex flex-col items-center gap-0.5 text-black/60" data-testid={`bottomnav-${it.label.toLowerCase()}`}>
          <it.icon className="w-5 h-5" />
          <span className="text-[10px] font-semibold">{it.label}</span>
        </button>
      ))}
      <a href={EXTERNAL_LINKS.AFFILIATE_LOGIN_URL} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-0.5 text-black/60" data-testid="bottomnav-account">
        <User className="w-5 h-5" />
        <span className="text-[10px] font-semibold">Account</span>
      </a>
    </nav>
  );
};

export default MobileBottomNav;
